<template>
  <div name="1">
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-image-area</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.image') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 10px 0 10px;"/> -->
    </v-toolbar>
    <select-image
      v-show="!collapseContent"
      v-model="content.Image"
      :isFullWidth="true"
      :enterpriseID="enterpriseID"
      :imageOld='content.Image'
      @input="handleChangeIsModified"
      style="margin-left:0px;margin-top:15px;margin-right: 0px;"
      width="100px"
    />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import SelectImage from '@/components/SelectImage'
  export default {
    components: {
      SelectImage
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      }
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

